module.exports = __webpack_public_path__ + "static/media/proj18_img1.c4141543.jpg";